import { useVpsHostingSectionContent } from './useVpsHostingSectionContent';
import { parseVpsHostingIncludedContent } from '../utils/vpsHostingContent';

export const useVpsHostingIncludedContent = () =>
  useVpsHostingSectionContent(parseVpsHostingIncludedContent);
